module.exports = __webpack_public_path__ + "img/topbar.a847d199.png";